/**
 * 图片模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取图片列表
export const pictureList = (params) => {
  return req.get('/wechat/picture/list', params);
}

// 新增图片
export const pictureAdd = (params) => {
  return req.post('/wechat/picture', params);
}

// 修改图片信息
export const pictureEdit = (params) => {
  return req.put('/wechat/picture', params);
}

// 删除图片信息
export const pictureDelete = (pictureIds) => {
  return req.delete(`/wechat/picture/${pictureIds}`);
}